import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useMemo,useState } from "react";
import withRouter from "../../withRouter";
import {
  CreateSetupIntent,
  AttachPaymentMethod
} from "../../action/card/paymentIntent";
import useResponsiveFontSize from "./useResponsiveFontSize";
import $ from "jquery";
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
import { PropTypes } from 'prop-types';
import { getUserContext } from "../../utils/helpers/storageUtils";


const useOptions = () => {
  const fontSize = useResponsiveFontSize();
  return useMemo(
    () => ({
      placeholder: 'Card Number',
      style: {
        base: {
          fontSize,
          color: "#4a4a4a",
          letterSpacing: "-0.4px",
          fontFamily: 'proxima-nova',
          fontWeight:'400',
          "::placeholder": {
            color: "#6c757d",
            fontSize:'18px',
            fontWeight:'500'
          },
          Height:"25px"          
          
        },
        invalid: {
          color: "#4a4a4a",
          placeholder: 'Card NO'
        },
      },
      
    }),
    [fontSize]
  );
};

const CardExpirOptions = () => {
  const fontSize = useResponsiveFontSize();
  
  return useMemo(
    () => ({
      placeholder: 'MM/YY',
      style: {
        base: {
          fontSize,
          color: "#4a4a4a",
          letterSpacing: "-0.4px",
          fontFamily: "proxima-nova",
          "::placeholder": {
            color: "#6c757d",
            fontSize:'18px',
            fontWeight:'400'
          }, 
          Height:"25px"
          
        },
        invalid: {
          color: "#4a4a4a",
          placeholder: 'Card NO'
        },
      },
      
    }),
    [fontSize]
  );
};

const CvvOptions = () => {
  const fontSize = useResponsiveFontSize();
  return useMemo(
    () => ({
      placeholder: 'CVV',
      style: {
        base: {
          fontSize,
          color: "#4a4a4a",
          letterSpacing: "-0.4px",
          fontFamily: "proxima-nova",
          "::placeholder": {
            color: "#6c757d",
            placeholder:"12345678",
            fontSize:'18px',
            fontWeight:'400'
          },           
          Height:"25px"
          
        },
        invalid: {
          color: "#4a4a4a",
          placeholder: 'Card NO'
        },
      },
      
    }),
    [fontSize]
  );
};

  // Click Events
  const clickEventForCardNumber = ()=>{
    return analyticsClickEvent('credit_card_number','');
  }

  const clickEventForCardMonthAndYr = () => {
    return analyticsClickEvent('credit_card_month_and_year','')
  }

  const clickEventForCardCvv = () => {
    return analyticsClickEvent('credit_card_cvv','')
  }

const PaymentForm = (props) => {
  console.log('paymentform');

  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const cvvOpt = CvvOptions();
  const cardExpOpt= CardExpirOptions();
  const eventCardNumber = clickEventForCardNumber();
  const eventCardMonthAndYr = clickEventForCardMonthAndYr();
  const eventCardCvv = clickEventForCardCvv();
  

  const [cardNoError, setcardNoError] = useState('');
  const [cardExpError, setcardExpError] = useState('');
  const [cardCvcError, setcardCvcError] = useState('');
  const [cardError, setCardError] = useState('');


  if (elements?.getElement(CardNumberElement) && $('#addCard').hasClass('show') === false) {
    console.log(elements.getElement(CardNumberElement));
    elements.getElement(CardNumberElement).clear();
    elements.getElement(CardExpiryElement).clear();
    elements.getElement(CardCvcElement).clear();
  }

  const onReadyCardNumberElement = () => {
    elements.getElement(CardNumberElement).clear();
    
    setcardNoError('');
  }
 
  const handleSubmit = async (event) => {
     document.getElementById("confirm-submit").disabled = true;
     analyticsClickEvent('add_card_popup_confirm','')
   console.log('handle submit',props.isCheckcardHolderValid);
    event.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      document.getElementById("confirm-submit").disabled=false
      return;
    }
    const res = await CreateSetupIntent(getUserContext());
    let secret = res.data.data.client_secret;

    //   // confirm card setup

    let confirmcardsetup = await stripe.confirmCardSetup(secret, {
      payment_method: {
        card: elements.getElement(CardNumberElement),
        billing_details: {
          // name: sessionStorage.getItem("UserName"),
          name: props.cardHolderName,
        },
      },
    });
    console.log("stripe confirm setup", confirmcardsetup);

   props.cardHolderCheckValidation();
   if(props.isCheckcardHolderValid != ''){
    document.getElementById("confirm-submit").disabled=false;
     return false;
   }
      if(confirmcardsetup.error  && cardNoError == '' && cardExpError == '' && cardCvcError == ''){
      setCardError(confirmcardsetup.error.message);
      console.log('error',confirmcardsetup.error.messsage);

      document.getElementById("confirm-submit").disabled=false; 
      return false;
    }
   
    if(confirmcardsetup.error != undefined){
      setCardError(confirmcardsetup.error.message);
      document.getElementById("confirm-submit").disabled=false;
      return false;
    }
    let attachPaymentMenthod = {
        paymentMethodId: confirmcardsetup.setupIntent.payment_method,
        ...getUserContext()
    }

    const response = await AttachPaymentMethod(attachPaymentMenthod);
    
    document.getElementById("confirm-submit").disabled=false;
    if(response.status===200){
      elements.getElement(CardNumberElement).clear();
      elements.getElement(CardExpiryElement).clear();
      elements.getElement(CardCvcElement).clear(); 
      sessionStorage.setItem('cardMessage', response.data.message);
      props.callCardProcessSucess(response.status);
    }

  };

  function onChangeCardNumberElement(event){
    console.log(event);
    
    if(event.error!==undefined){
      setcardNoError(event.error.message);
    }else{
      setcardNoError('');
      setCardError('');
    }
  }

  function onReadyCardExpiryElement(){
    setcardExpError('');
  }

  function onChangeCardExpiryElement(event){
    // analyticsTypeEvent('credit_card_month_and year') 
    console.log("CardNumberElement [change]", event);
    if(event.error!==undefined){
      setcardExpError(event.error.message);
    }else{
      setcardExpError('');
      
    }
  }

  function onReadyCardCvcElement(){
    setcardCvcError('');
  }

  function onChangeCardCvcElement(event){
    // analyticsTypeEvent('credit_card_cvv') 
    console.log("CardNumberElement [change]", event);
              
    if(event.error!==undefined){
      setcardCvcError(event.error.message);
    }else{
      setcardCvcError('');
      
    }
  }

  console.log(stripe)
  return (
    
    <form onSubmit={handleSubmit}>
      <label>
        {/* Card number */}
        <div className="StripeElement card_number proxima-nova-bold">
          <CardNumberElement
            options={options}
            onReady={onReadyCardNumberElement}
            onChange={onChangeCardNumberElement}
            onClick = {eventCardNumber}            
          />
          <p className="error-message card-holder-error">
            <span>{cardNoError}</span>
          </p>
        </div>
      </label>
      <label className="mb-3">
        {/* Expiration date */}
        <div className="StripeElement exp_date custom-strip-field">
          <CardExpiryElement
            className="StripeExpiery"
            options={cardExpOpt}
            onReady={onReadyCardExpiryElement}
            onChange={onChangeCardExpiryElement}
          
            onClick = {eventCardMonthAndYr}
          />
          <p className="error-message card-holder-error">
            <span>{cardExpError}</span>
          </p>
        </div>
        <div className="StripeElement cvc_number">
          <CardCvcElement
            options={cvvOpt}
            onReady={onReadyCardCvcElement}
            onChange={onChangeCardCvcElement}
            onClick = {eventCardCvv}
          />
          <p className="error-message card-holder-error">
            <span>{cardCvcError}</span>
          </p>
        </div>
      </label>
      {/* <label>
        { CVC }
        
      </label> */}
      {cardNoError=='' && cardExpError=='' && cardCvcError=='' &&
       <p className="error-message card-error">
            <span>{cardError}</span>
          </p>
          }
      <br />
      <p className={cardExpError !=='' || cardCvcError !== '' ?'add-card--note-max-margin-top text-left': 'add-card--note-min-margin-top text-left'}>
        <span className="font-weight-bold">Please note: </span> Making payments by credit card may result in getting into more debt, so please carefully consider your card choice. <a href="https://www.shophumm.com/uk/faqs/what-should-i-consider-before-using-a-credit-card-against-my-loan-agreement/" target='_blank' 
        rel="noopener noreferrer" className="add-card--click-here-link" >Click here</a> for more info.
      </p>
     
      <button type="submit" className="btn btn-primary mt-3" id="confirm-submit" disabled={!stripe}>
        Confirm
      </button>
     
    </form>
  );
};


PaymentForm.propTypes = {
  isCheckcardHolderValid: PropTypes.string,
  cardHolderName: PropTypes.string,
  cardHolderCheckValidation: PropTypes.func,
  callCardProcessSucess: PropTypes.func,

}
export default withRouter(PaymentForm);
